/** Engraved-style divider: rule, fleuron, rule. */
export default function Ornament({ light = false, className = '' }) {
  return (
    <div className={`ornament ${light ? 'ornament--light' : ''} ${className}`.trim()} aria-hidden="true">
      <span className="ornament__rule" />
      <svg width="46" height="18" viewBox="0 0 46 18">
        <path d="M23 2c-3 4-3 10 0 14 3-4 3-10 0-14Z" fill="currentColor" />
        <path d="M21 9c-5-5-11-5-16 0 5 3 11 3 16 0Zm4 0c5-5 11-5 16 0-5 3-11 3-16 0Z" fill="currentColor" opacity="0.75" />
        <rect x="1" y="8" width="3" height="2" fill="currentColor" />
        <rect x="42" y="8" width="3" height="2" fill="currentColor" />
      </svg>
      <span className="ornament__rule" />
    </div>
  );
}
